<p-card>
  <h4>Inspector</h4>
</p-card>

<div class="edit-inspector-form-container">
  <form (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="name">Name</label>
          <input
            type="text"
            class="form-control"
            name="name"
            id="name"
            [maxlength]="200"
            [(ngModel)]="model.name"
            required
            #name="ngModel"
            [ngClass]="{ 'is-invalid': f.submitted && name.invalid }"
          />
          <div *ngIf="f.submitted && name.invalid" class="invalid-feedback">
            <div *ngIf="name.errors.required">Name is required</div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label for="pharmacyId">Address Line 1</label>
          <input
            type="text"
            class="form-control"
            name="addressLine1"
            id="addressLine1"
            [(ngModel)]="model.addressLine1"
            placeholder="Inform street address"
            required
            #addressLine1="ngModel"
            [ngClass]="{ 'is-invalid': f.submitted && addressLine1.invalid }"
          />
          <div
            *ngIf="f.submitted && addressLine1.invalid"
            class="invalid-feedback"
          >
            <div *ngIf="addressLine1.errors.required">
              Address Line 1 is required
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label for="pharmacyId">Address Line 2</label>
          <input
            type="text"
            class="form-control"
            name="addressLine2"
            id="addressLine2"
            [(ngModel)]="model.addressLine2"
            placeholder="Inform unit number"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <label for="pharmacyId">Postal Code</label>
          <input
            type="text"
            postalCodeMask
            class="form-control"
            name="postalCode"
            id="postalCode"
            [maxlength]="7"
            [(ngModel)]="model.postalCode"
            oninput="this.value = this.value.toUpperCase()"
            required
            #postalCode="ngModel"
            [ngClass]="{ 'is-invalid': f.submitted && postalCode.invalid }"
          />
          <div
            *ngIf="f.submitted && postalCode.invalid"
            class="invalid-feedback"
          >
            <div *ngIf="postalCode.errors.required">
              Postal Code is required
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-2">
        <div class="form-group">
          <label for="pharmacyId">City</label>
          <select
            id="Id"
            [(ngModel)]="model.city"
            class="form-control"
            name="city"
            value="Halifax"
            required
            #city="ngModel"
            [ngClass]="{ 'is-invalid': f.submitted && city.invalid }"
          >
            <option [ngValue]="k.Id" *ngFor="let k of listCitiesOrdered">
              {{ k.Name }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-2">
        <div class="form-group">
          <label for="pharmacyId">Province</label>
          <select
            id="Id"
            #Id="ngModel"
            class="hideLabel form-control"
            [(ngModel)]="model.province"
            name="province"
            disabled="true"
            value="NS"
            required
            #province="ngModel"
          >
            <option [ngValue]="k.Id" *ngFor="let k of listProvinces">
              {{ k.Name }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-2">
        <div class="form-group">
          <label for="pharmacyId">Country</label>

          <select
            id="Id"
            class="hideLabel form-control"
            [(ngModel)]="model.country"
            name="country"
            disabled="true"
            value="CA"
            required
            #country="ngModel"
          >
            <option [ngValue]="k.Id" *ngFor="let k of listCountries">
              {{ k.Name }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <label for="pharmacyId">Phone Primary</label>
          <input
            type="text"
            appPhoneMask
            class="form-control"
            name="primaryPhone"
            id="primaryPhone"
            required
            [(ngModel)]="model.primaryPhone"
            #primaryPhone="ngModel"
            [ngClass]="{ 'is-invalid': f.submitted && primaryPhone.invalid }"
          />

          <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
            <div *ngIf="email.errors.required">Phone Primary is required</div>
          </div>
        </div>
      </div>

      <div class="col-md-2">
        <div class="form-group">
          <label for="pharmacyId">Phone Secondary</label>
          <input
            type="text"
            appPhoneMask
            class="form-control"
            name="secondaryPhone"
            id="secondaryPhone"
            [(ngModel)]="model.secondaryPhone"
          />
        </div>
      </div>

      <div class="col-md-2">
        <div class="form-group">
          <label for="pharmacyId">E-mail</label>
          <input
            type="email"
            class="form-control"
            name="email"
            id="email"
            [(ngModel)]="model.email"
            placeholder="info@example.com"
            required
            #email="ngModel"
            [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
          />

          <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
            <div *ngIf="email.errors.required">Email address is required</div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <button class="btn btn-success">
        <span class="glyphicon glyphicon-ok"></span> Save
      </button>
      <button class="btn btn-info" type="button" (click)="previousForm()">
        <span class="glyphicon glyphicon-chevron-left"></span> Back
      </button>
    </div>
  </form>
</div>
